import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Header, Projects, StartInvestments, StepByStep, WeShowYou } from './sections/';
import PQRS from '../Home/sections/PQRS';
import { scrollToSection } from '../../helpers/functions';
import { Community } from '../Home/sections/Community';
import { Learning } from '../Home/sections/Learning';
import Medios from '../Home/sections/medios';
import { getHomeIndicators } from '../../services/globalServices';
import { Supplierbar } from '../AboutUs/sections';
import useTitle, { useDescription, useKeywords } from '../../hooks/useSEO';


function NewHome() {

    React.useEffect(() => {

        caches.keys().then((names) => {
            names.forEach((name) => {
                caches.delete(name);
            });
        });

        if (window.location.hash) {
            const hash = window.location.hash;
            const section = hash.replace("#", '');
            let distance = 100;

            if (section === 'simulator') {
                distance = 160
            }

            if (section === 'streams') {
                distance = 120
            }

            if (section === 'projects') {
                distance = 180
            }

            scrollToSection(section, distance);
        }

    }, []);

    const [indicators, setIndicators] = useState({
        investors: '',
        retorno: '',
        totalInvestmentValue: 0,
    })
    useTitle('Inversiones inmobiliarias para las nuevas generaciones | Lokl Colombia');
    useKeywords("simulador de inversiones, simulador de dinero, Inversiones digitales, Proyectos inmobiliarios, empieza a invertir, inversion nuevas generaciones, simulador inversion bienes raices, oportunidades de inversion, Comunidad de inversion, invertir en fracciones inmobiliarias, inversion inmobiliaria segura, invertir en inmuebles, empezar a invertir, inversiones colaborativa, proyectos con impacto, ideas de inversion, como hacer inversiones, inversiones en renta variable, fondo de inversion colectiva, calculadora inversiones, proyecto de inversion hotel, como calcular el retorno de inversion, buenas inversiones con poco dinero, calcular la ganancia de una inversion, como ser inversionista en colombia");
    useDescription('Descubre cómo Lokl revoluciona las inversiones inmobiliarias. Invierte desde bajos montos en proyectos únicos, 100% digitales y diseñados para el futuro que deseas vivir.')
    useEffect(() => {
        const getData = async () => {
            const { data } = await getHomeIndicators();
            setIndicators({
                ...indicators,
                investors: data?.data?.totalInvestors,
                totalInvestmentValue: data?.data?.totalInvested
            })
        }
        getData();
        // eslint-disable-next-line
    }, []);

    return (
        <main className="bg-[#FBFBFB] overflow-x-hidden">
            <header>
            <Header />
            
            <Projects />
            
  
            </header>

            <article className="my-20 container w-full sm:max-w-[640px] md:max-w-[768px] lg:max-w-[1180px]">
                <StartInvestments />
            </article>

            <article className="mt-36 w-full container">
                <WeShowYou />
            </article>
            
            <section className="container w-full sm:max-w-[640px] md:max-w-[768px] lg:max-w-[1180px]">
                <article className="w-full container">
                    <StepByStep />
                </article>
                
            
                <article className="my-36">
                    <Community investors={indicators.investors} />
                </article>
                
            
                <article className="my-32">
                    <Medios />
                </article>
            
                <article className="my-20">
                    <Learning />
                </article>
                
        
                <article>
                    <PQRS />
                </article>
    </section>
    

    <aside className="mt-16">
        <Supplierbar />
    </aside>

    {/* Modales comentados */}
    {/* <ModalVideo /> */}
    {/* <ModalGrowupUnit /> */}
    {/* <ModalShowUnit /> */}
</main>

    );
}

export default NewHome;
